import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const RecurringExpenseModals = ({
  showAddExpenseModal,
  handleCloseModal,
  message,
  newExpense,
  handleNewExpenseChange,
  submitAddExpense,
  familyMembers,
  showEditExpenseModal,
  handleCloseEditModal,
  editingExpense,
  handleEditExpenseChange,
  submitEditExpense,
  showDeleteExpenseModal,
  handleCloseDeleteModal,
  deletingExpense,
  submitDeleteExpense,
}) => {
  return (
    <>
      <Modal show={showAddExpenseModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Add Recurring Expense</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {message && <p className="alert alert-info">{message}</p>}
          <Form>
            <Form.Group>
              <Form.Label>Name *</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={newExpense.name}
                onChange={handleNewExpenseChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Type *</Form.Label>
              <Form.Control
                as="select"
                name="type"
                value={newExpense.type}
                onChange={handleNewExpenseChange}
              >
                <option value="basic">Basic</option>
                <option value="groceries">Groceries</option>
                <option value="transport">Transport</option>
                <option value="eatout">Eat Out</option>
                <option value="travel">Travel</option>
                <option value="other">Other</option>
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Owner *</Form.Label>
              <Form.Control
                as="select"
                name="owner"
                value={newExpense.owner}
                onChange={handleNewExpenseChange}
              >
                <option value="">Select Owner</option>
                {familyMembers.map((member) => (
                  <option key={member.id} value={member.username}>
                    {member.username}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Check
                type="checkbox"
                label="TR"
                name="tr"
                checked={newExpense.tr}
                onChange={handleNewExpenseChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Amount *</Form.Label>
              <Form.Control
                type="number"
                name="amount"
                value={newExpense.amount}
                onChange={handleNewExpenseChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Location</Form.Label>
              <Form.Control
                type="text"
                name="location"
                value={newExpense.location}
                onChange={handleNewExpenseChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={submitAddExpense}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>

      {editingExpense && (
        <Modal show={showEditExpenseModal} onHide={handleCloseEditModal}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Recurring Expense</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {message && <p className="alert alert-info">{message}</p>}
            <Form>
              <Form.Group>
                <Form.Label>Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={editingExpense.name}
                  onChange={handleEditExpenseChange}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Type *</Form.Label>
                <Form.Control
                  as="select"
                  name="type"
                  value={editingExpense.type}
                  onChange={handleEditExpenseChange}
                >
                  <option value="basic">Basic</option>
                  <option value="groceries">Groceries</option>
                  <option value="transport">Transport</option>
                  <option value="eatout">Eat Out</option>
                  <option value="travel">Travel</option>
                  <option value="other">Other</option>
                </Form.Control>
              </Form.Group>
              <Form.Group>
                <Form.Label>Owner *</Form.Label>
                <Form.Control
                  as="select"
                  name="owner"
                  value={editingExpense.owner}
                  onChange={handleEditExpenseChange}
                >
                  <option value="">Select Owner</option>
                  {familyMembers.map((member) => (
                    <option key={member.id} value={member.username}>
                      {member.username}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
              <Form.Group>
                <Form.Check
                  type="checkbox"
                  label="TR"
                  name="tr"
                  checked={editingExpense.tr}
                  onChange={handleEditExpenseChange}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Amount *</Form.Label>
                <Form.Control
                  type="number"
                  name="amount"
                  value={editingExpense.amount}
                  onChange={handleEditExpenseChange}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Location</Form.Label>
                <Form.Control
                  type="text"
                  name="location"
                  value={editingExpense.location}
                  onChange={handleEditExpenseChange}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseEditModal}>
              Close
            </Button>
            <Button variant="primary" onClick={submitEditExpense}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {deletingExpense && (
        <Modal show={showDeleteExpenseModal} onHide={handleCloseDeleteModal}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Recurring Expense</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete the expense:{" "}
            <strong>{deletingExpense.name}</strong>?
            {message && <p className="text-danger mt-2">{message}</p>}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseDeleteModal}>
              Cancel
            </Button>
            <Button variant="danger" onClick={submitDeleteExpense}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default RecurringExpenseModals;
